const TYPES = {
  INFO: 'info',
  WARN: 'warning',
  SUCCESS: 'success',
  ERROR: 'error',
};

const getMessagesList = (message) => {
  if (!message) throw new Error('Error creating notification: message param is mandatory!');
  if (typeof message !== 'string' && !Array.isArray(message)) {
    throw new Error('Error creating notification: message must be a string or an array of strings!');
  }
  if (Array.isArray(message)) {
    if (message.length === 0) throw new Error('Error creating notification: message array must not be empty!');
    if (Array.isArray(message) && message.some((str) => typeof str !== 'string')) throw new Error('Error creating notification: message array must contain strings!');
  }

  return typeof message === 'string' ? [message] : message;
};

function b64EncodeUnicode(str) {
  // See https://developer.mozilla.org/es/docs/Glossary/Base64
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(`0x${p1}`)));
}

function hashMessages(messages) {
  // Combines messages into one string, then hashes the string with base 64
  return b64EncodeUnicode(messages.reduce((acc, el) => acc + el));
}

const initializeNotificationProps = (message, props = {}, timeout) => {
  const messages = getMessagesList(message);
  return ({
    id: hashMessages(messages),
    top: true,
    ...props,
    messages,
    timeout: timeout || 0
  });
};

export const createNotification = (message, type, props, timeout) => ({
  color: Object.values(TYPES).indexOf(type) >= 0 ? type : TYPES.INFO,
  ...initializeNotificationProps(message, props, timeout),
});
export const createInfoNotification = (message, props, timeout) => ({
  color: TYPES.INFO,
  ...initializeNotificationProps(message, props, timeout),
});
export const createSuccessNotification = (message, props = {}, timeout = 1000) => ({
  color: TYPES.SUCCESS,
  ...initializeNotificationProps(message, props, timeout),
});
export const createWarningNotification = (message, props = {}, timeout = 3000) => ({
  color: TYPES.WARN,
  ...initializeNotificationProps(message, props, timeout),
});
export const createErrorNotification = (message, props = {}, timeout = 5000) => ({
  color: TYPES.ERROR,
  ...initializeNotificationProps(message, props, timeout),
});
